import React, { useEffect, useMemo, useState } from "react";
import Modal from "../../Components/Kanban/Modal/Modal";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import filterSign from "../../Images/filterSign.svg";
import { useSession } from "../../authentications/SessionContext";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { unLink } from "../../DataApi/unlink";
import { handleResponse } from "../../utilities/handleResponse";
import { TableContainer } from "../../Components/StyledComponents/TableContainer/TableContainer";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { MainSectionOfPage } from "../../Components/StyledComponents/FirstSectonOfPages/MainSectionOfPage";
import TableHeader from "../../Components/Table/TableHeader";
import { CATEGORIES_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import TableBody from "../../Components/Table/TableBody";
import Pagination from "../../Components/Table/TableFooter/Pagination";
import TableToolbar from "../../Components/Table/TableToolbar";
import { categoriesAction } from "../../Redux/Reducers/CategoriesSlice";
import NewCategory from "../../Components/ProductModals/NewCategory";
import Tree from "../../Components/Tree/Tree";
import { primaryColor } from "../../utilities/colors";

const CategoriesSortListOption = [
  { label: "Category", value: "display_name" },
  { label: "Parent Category", value: "parent_id" },
  { label: "Website", value: "website_id" },
];
const CategoriesViewTypeOption = [{ type: "List" }, { type: "Tree" }];

const NewButton = styled.button`
  border-radius: 15px;
  background-color: ${(props) =>
    props["data-isvtex"] ? "#000000" : "#ff5837"};
  color: ${(props) =>
    props["data-isvtex"] ? primaryColor.primary : "#ffffff"};
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 10px;
`;
const ProductsContainer = styled.div`
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 2rem;
  margin: 30px;
  border-radius: 20px;
`;

const Categories = () => {
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX, is_vtex_admin, is_vtex_omantal } =
    sessionInfo;
  const { categoriesList, length, loading } = useSelector(
    (state) => state.category
  );
  const groupedCategories = categoriesList.reduce((acc, category) => {
    const parentKey = category.parent_id ? category.parent_id[0] : "undefined";
    if (!acc[parentKey]) {
      acc[parentKey] = [];
    }
    acc[parentKey].push(category);
    return acc;
  }, {});
  // console.log("categoriesList", categoriesList, groupedCategories);
  const dispatch = useDispatch();

  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();

  const [searchQuery, setSearchQuery] = useState("");

  const [categoriesSort, setCategoriesSort] = useState(
    CategoriesSortListOption[0].value
  );
  const [viewType, setViewType] = useState(CategoriesViewTypeOption[0].type);
  const [filterDirection, setFilterDirection] = useState("desc");

  const { language, translations } = useLanguage();
  const t = translations[language];
  const [selectedRows, setSelectedRows] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleCreateClick = () => {
    setIsCreateModalOpen(true);
  };
  const handleCloseModal = () => {
    setSelectedRecord([]);
    setIsCreateModalOpen(false);
    setSelectedRecord({});
  };

  const handleDeleteSelection = () => {
    setDisableModalButton(true);

    unLink({
      id: [...selectedRows],
      company_id,
      context,
      model: "product.public.category",
    }).then((response) => {
      response = JSON.parse(response);
      if (response.result) {
        refetchData();
        setSelectedRows([]);
        setOpenConfirmationModal(false);
      }
      handleResponse({
        response,
        setMetaData,
        setTitle,
        successMessage: "Product Deleted Successfully",
      });
      setDisableModalButton(false);
    });
  };

  const handleDeleteOrder = () => {
    setOpenConfirmationModal(true);
    setTitle("");
    setMetaData({
      dangerouslySetInnerHTML: "",
      primaryButton: "Yes",
      secondaryButton: "No",
    });
  };
  const handleEditOrder = (record) => {
    setIsCreateModalOpen(true);
    setSelectedRecord({ id: record });
  };
  const toggleSelectAll = () => {
    if (selectedRows.length === categoriesList.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(categoriesList.map((record) => record.id));
    }
  };

  const handleChangeProductSort = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handleChangeProductSortType = (e) => {
    setCategoriesSort(e.target.value);
  };
  const handleChangeViewType = (e) => {
    setViewType(e.target.value);
    // console.log("viewType", viewType);
  };

  const refetchData = () => {
    dispatch(
      categoriesAction.fetchCategoriesData({
        context,
        company_id,
        pagination: {
          offset: (currentPage - 1) * itemsPerPage,
          limit: viewType === "List" ? itemsPerPage : 80,
        },
        search: {
          query: searchQuery,
          specific:
            isVTEX && is_vtex_admin && is_vtex_omantal
              ? ["vtexAdminCateg", "ilike", "true"]
              : null,
          type: "",
        },
        sort: {
          type: categoriesSort || "",
          dir: filterDirection,
        },
      })
    );
  };

  useEffect(() => {
    refetchData();
  }, [currentPage, searchQuery, categoriesSort, filterDirection, viewType]);

  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
    // setIsDetailsModalOpen(false); // Close the details modal whenever a checkbox is clicked
  };

  const updatedCategoriesTableListView = useMemo(() => {
    const updatedList = [...CATEGORIES_LIST_TABLE_VIEW];
    updatedList.splice(0, 1, {
      ...updatedList[0],
      handleCell: (data, item) => {
        return (
          <input
            type="checkbox"
            style={{ accentColor: isVTEX ? "#baf76a" : "#ff5837" }}
            checked={
              data
                ? selectedRows.includes(data[item.name])
                : selectedRows.length === categoriesList?.length
            }
            onChange={() =>
              data ? toggleSelectRow(data[item.name]) : toggleSelectAll()
            }
          />
        );
      },
    });
    updatedList.splice(1, 1, {
      ...updatedList[1],

      handleCell: (data, item) => (
        <span role="button" onClick={() => handleEditOrder(data.id)}>
          {data[item.name]}
        </span>
      ),
    });
    // console.log("first", updatedList[3]);
    // updatedList.splice(3, 1, {
    //   ...updatedList[3],
    //   handleCell: (data, item) => (
    //     <span role="button" onClick={() => handleEditOrder(data.id)}>
    //       {data[item.name]}
    //     </span>
    //   ),
    // });
    return updatedList;
  }, [selectedRows, categoriesList]);

  return (
    <>
      <ConfirmationModal
        handleYes={handleDeleteSelection}
        handleNo={() => setOpenConfirmationModal(false)}
      />
      <MainSectionOfPage className="d-flex justify-content-end orders-first-section">
        <div className="btn_and_icons">
          <NewButton onClick={handleCreateClick} data-isvtex={isVTEX}>
            + {t["New Category"]}
          </NewButton>
          {isCreateModalOpen && (
            <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
              <NewCategory
                selectedRecord={selectedRecord}
                handleCloseModal={(modalValue) => {
                  handleCloseModal();
                  setSelectedRows([]);
                  refetchData();
                }}
                refetchData={refetchData}
              />
            </Modal>
          )}
          {viewType === "List" && (
            <div className="d-none d-md-flex Filter_icon_div">
              <img
                src={filterSign}
                alt="filter"
                style={{
                  transform: `rotate(${
                    filterDirection === "asc" ? "180" : "0"
                  }deg)`,
                }}
                onClick={handleChangeProductSort}
              />
            </div>
          )}
          <div className=" d-none d-md-flex dropdown_list_div d-flex">
            <p className="sort_by">View Type:</p>
            <select
              className="custom-select"
              onChange={handleChangeViewType}
              value={viewType}
              name="type"
            >
              {CategoriesViewTypeOption.map((option, index) => (
                <option
                  key={index}
                  value={option.type}
                  style={{ padding: "15px 0" }}
                >
                  {option.type}
                </option>
              ))}
            </select>
          </div>
          {viewType === "List" && (
            <div className=" d-none d-md-flex dropdown_list_div d-flex">
              <p className="sort_by">Sort by:</p>
              <select
                className="custom-select"
                onChange={handleChangeProductSortType}
                value={categoriesSort}
                name="type"
              >
                {CategoriesSortListOption.map((option, index) => (
                  <option
                    key={index}
                    value={option.value}
                    style={{ padding: "15px 0" }}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </MainSectionOfPage>
      <ProductsContainer>
        <TableContainer data-isvtex={isVTEX}>
          <TableToolbar
            handleDelete={handleDeleteOrder}
            handleEditList={handleEditOrder}
            setSearchQuery={setSearchQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          {viewType === "List" ? (
            <table className="table">
              <TableHeader tableHeaderList={updatedCategoriesTableListView} />
              <TableBody
                tableData={categoriesList}
                tableBodyList={updatedCategoriesTableListView}
                isLoadingData={loading === "pending" || loading === "idle"}
                checkIsLoadingData
              />
            </table>
          ) : (
            <Tree
              groupedCategories={groupedCategories}
              updatedCategoriesTableListView={updatedCategoriesTableListView}
              isLoadingData={loading === "pending" || loading === "idle"}
              isVTEX={isVTEX}
            />
          )}
          <Pagination
            ListViewData={categoriesList}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </TableContainer>
      </ProductsContainer>
    </>
  );
};

export default Categories;
